import { render, staticRenderFns } from "./VersionDisplay.vue?vue&type=template&id=0eaec2a9&"
import script from "./VersionDisplay.vue?vue&type=script&lang=ts&"
export * from "./VersionDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./VersionDisplay.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports